// src/utils/productFormData.js

import { getApiKey } from '../Config/fieldMapping';

export const buildProductFormData = (formData,config) => {
  const body = new FormData();
  const attributes = [];
  (config.specifications || []).forEach((spec) => {
    const value = formData[spec.key];
    if (["sku", "barcode", "color_ids"].includes(spec.key)) {
        return;
    }
    if (value !== "" && value !== null && value !== undefined) {
      attributes.push({
        key: spec.key,
        value: value,
      });
    }
  });
  Object.keys(formData).forEach((key) => {
    const value = formData[key];
    if (value === "" || value === null || value === undefined) return;
     if ((config.specifications || []).some((s) => s.key === key)) {
      return;
    }
  const apiKey = getApiKey(key) || key;
    // if (key === 'variants' && Array.isArray(value) && value.length > 0) {
    //  body.append(apiKey, JSON.stringify(value));
    // } 
if (key === "variants" && Array.isArray(value)) {

    value.forEach((variant, index) => {

        body.append(
            `variants[${index}][attribute_name]`,
            variant.attribute_name || ""
        );

        body.append(
            `variants[${index}][attribute_value]`,
            variant.attribute_value || ""
        );

        body.append(
            `variants[${index}][attribute_value_id]`,
            variant.attribute_value_id ?? ""
        );

        body.append(
            `variants[${index}][extra_price]`,
            variant.extra_price || 0
        );

        body.append(
            `variants[${index}][stock]`,
            variant.stock || 0
        );

        body.append(
            `variants[${index}][sku]`,
            variant.sku || ""
        );

        // body.append(
        //     `variants[${index}][image_url]`,
        //     variant.image_url || ""
        // );
// if (variant.image instanceof File) {
//     body.append(
//         `variants[${index}][image]`,
//         variant.image
//     );
// }

// body.append(
//     `variants[${index}][image_url]`,
//     variant.image_url || ""
// );
        body.append(
            `variants[${index}][is_default]`,
            variant.is_default ? 1 : 0
        );

    });

    return;
}
if (key === "images" && Array.isArray(value)) {

    value.forEach((img, index) => {

        // File
        if (img instanceof File) {

            body.append(`images[${index}][image]`, img);

            body.append(`images[${index}][image_type]`, "gallery");
            body.append(`images[${index}][color]`, "");
            body.append(`images[${index}][title]`, img.name);
            body.append(`images[${index}][alt_text]`, img.name);
            body.append(`images[${index}][sort_order]`, index + 1);
            body.append(`images[${index}][is_primary]`, index === 0 ? 1 : 0);
        }
        // Object with file
        else if (img?.file instanceof File) {
            body.append(`images[${index}][image]`, img.file);
            body.append(`images[${index}][image_type]`, img.image_type || "gallery");
            body.append(`images[${index}][color]`, img.color || "");
            body.append(`images[${index}][title]`, img.title || img.file.name);
            body.append(`images[${index}][alt_text]`, img.alt_text || img.file.name);
            body.append(`images[${index}][sort_order]`, img.sort_order || index + 1);
            body.append(`images[${index}][is_primary]`, img.is_primary || 0);
        }

    });

    return;
}
// SKU normal field
if (key === "sku") {
    body.append(apiKey, value);
    return;
}
if (key === "barcode") {
    body.append("barcode", value);
    return;
}
// Color Select
if (key === "color_ids") {
    if (Array.isArray(value)) {
        body.append("color", value.map(item => item.value ?? item).join(","));
    } else {
        body.append("color", value?.value ?? value);
    }
    return;
}

    else if (Array.isArray(value)) {
      if (value.length > 0) {
        body.append(apiKey, JSON.stringify(value));
    }

    
    }
    //  else if (key === 'image' && value instanceof File) {

    //   body.append(apiKey, value);
    // }
  
    
     else {
      body.append(apiKey, value);
    }
  });
  // body.append("attributes", JSON.stringify(attributes));
//   if (attributes.length > 0) {

//     attributes.forEach((attr, index) => {

//         body.append(
//             `attributes[${index}][attr_key]`,
//             attr.key
//         );

//         body.append(
//             `attributes[${index}][attr_value]`,
//             attr.value
//         );

//     });

// }
  if (attributes.length > 0) {
    attributes.forEach((attr, index) => {
      body.append(`attributes[${index}][attr_key]`, attr.key);
      body.append(`attributes[${index}][attr_value]`, attr.value);
    });
  }


  return body;
};
